import { Grid } from "@mui/material";
import { useAppDispatch, useImagePath } from "hooks";
import { dailyGiftAssets } from "assets/cdn";
import { onClosePopUp, onDIPtrigger } from "redux/slices";
import { Body, Button, Container, Header, Title } from "./styles";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useNavigate } from "react-router-dom";
import { useLinks } from "hooks/useLinks";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { useEffect } from "react";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";

interface DailyRewardEarnedProps {}

export const DailyRewardEarned: React.FC<DailyRewardEarnedProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const navigate = useNavigate();
	const headImageUrl = getImage(dailyGiftAssets.popups.earned);
	const { syncUserTracker } = useWebStoreContext();
	const links = useLinks();
	const scale = useCalculateScale(343 + 40, 397 + 40);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "daily_gift_completion_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type
		});
	};

	const onClick = () => {
		reportAnalytics({
			event_name: "continue_shopping_click"
		});
		navigate(links.shop.path);
		dispatch(onDIPtrigger({ triggerType: "collectDailyGift" }));
		syncUserTracker();
		dispatch(onClosePopUp());
	};

	const onClose = () => {
		reportAnalytics({
			event_name: "dialog_x_closed"
		});
		dispatch(onDIPtrigger({ triggerType: "collectDailyGift" }));
		syncUserTracker();
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		reportAnalytics({ event_name: "dialog_shown" });
	}, []);

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header data-image={headImageUrl}></Header>
			<Body>
				<Title>Your Free Daily Gift was sent to your inbox in-game!</Title>
				<Grid container spacing={2}>
					<Grid item xs={12} display="flex" justifyContent="center">
						<Button
							variant="contained"
							themeColor="secondary"
							onClick={onClick}
						>
							Continue Shopping
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="daily_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
